import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const LanguageSelector = () => {
    const { language, toggleLanguage } = useLanguage();

    return (
        <div className="flex items-center bg-[#F3F3F3] rounded-full p-1 border border-gray-200">
            <button
                onClick={() => toggleLanguage('en')}
                className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-[11px] font-black transition-all duration-200 cursor-pointer ${
                    language === 'en' ? 'bg-black text-white shadow-sm' : 'text-gray-600 hover:text-black'
                }`}
                title="English"
            >
                E
            </button>
            <button
                onClick={() => toggleLanguage('ta')}
                className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-200 cursor-pointer ${
                    language === 'ta' ? 'bg-black text-white shadow-sm' : 'text-gray-600 hover:text-black'
                }`}
                title="Tamil"
            >
                த
            </button>
            <button
                onClick={() => toggleLanguage('hi')}
                className={`w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all duration-200 cursor-pointer ${
                    language === 'hi' ? 'bg-black text-white shadow-sm' : 'text-gray-600 hover:text-black'
                }`}
                title="Hindi"
            >
                ह
            </button>
        </div>
    );
};

export default LanguageSelector;
